import { Box, Button, SxProps, Theme, Typography } from '@mui/material'

import StyledWrap from 'components/StyledWrap'
import { useCompany } from 'utils/company'

const styles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  title: {
    fontWeight: '500',
    mb: '8px',
  },
  text: {
    mb: '16px',
    maxWidth: '190px',
    fontSize: '12px',
    color: 'text.secondary',
  },
  button: {
    fontWeight: 500,
    p: '8px 48px',
    borderColor: 'primary.light',
  },
}

export default function ContactSupport(): JSX.Element | null {
  const { data: company } = useCompany()
  const supportEmail = company?.support_email

  if (supportEmail === null || supportEmail === undefined) {
    return null
  }

  return (
    <StyledWrap elementName="ContactSupport">
      <Box className="main-sidebar-contact" sx={styles.container}>
        <Typography variant="body1" component="p" sx={styles.title}>
          Questions?
        </Typography>
        <Typography variant="body2" component="p" sx={styles.text}>
          Chat with us, or send us an email
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          target="_blank"
          href={`mailto:${supportEmail}`}
          sx={styles.button}
        >
          Contact Support
        </Button>
      </Box>
    </StyledWrap>
  )
}
